export const getServiceWithProductQuestions = offering => {
  const services =
    offering && Array.isArray(offering.ServicesInOffering)
      ? offering.ServicesInOffering
      : [];

  return (
    services.find(
      service =>
        Array.isArray(service.productCatalogQuestions) &&
        service.productCatalogQuestions.length > 0
    ) || services[0]
  );
};
